import { Link } from "react-router-dom";
import { Car, LayoutDashboard, History, Settings } from "lucide-react";

const Sidebar = ({ activePage }) => {
  const getLinkClass = (pageName) => {
    return `flex items-center gap-3 p-2 rounded-md transition-colors ${
      activePage === pageName
        ? "bg-gray-700 font-semibold"
        : "hover:bg-gray-700"
    }`;
  };

  return (
    <aside className="w-60 bg-gradient-to-b from-slate-500 to-slate-800 text-white p-6 hidden md:flex flex-col">
      <img src="/nova_logo.png" alt="Logo Locgram" className="w-100 h-auto mb-6" />
      <nav className="flex flex-col gap-4">
        <Link
          to="#"
          className={`${getLinkClass("")}`}
          tabIndex={-1}
          aria-disabled="true"
        >
          <Car size={20} />
          <span>Veículo</span>
        </Link>

        {/*
        <Link 
            to="#" 
            className={getLinkClass("")}
            tabIndex={-1}
            aria-disabled="true"
          >
          <LayoutDashboard size={20} />
          <span>Dashboard</span>
        </Link>
        */}

        {/*
        <Link 
            to="#" 
            className={getLinkClass("")}
            tabIndex={-1}
            aria-disabled="true"
          >
          <History size={20} />
          <span>Histórico</span>
        </Link>
        */}

        {/*
        <Link 
            to="#" 
            className={getLinkClass("")}
            tabIndex={-1}
            aria-disabled="true"
          >
          <Settings size={20} />
          <span>Configurações</span>
        </Link>
        */}
      </nav>
    </aside>
  );
};

export default Sidebar;
